import { ApBaseClass } from 'webcommon/shared';
import { Directive } from '@angular/core';

// This can contain stuff shared across ui directives
@Directive()
export class ApBaseDirective extends ApBaseClass {
}
